import React from 'react';
import { Link } from 'react-router-dom';

const ReplaceLink = (props) => <Link replace {...props} />;

export default ReplaceLink;
